/**
 * @file jobType.ts
 *
 * @fileoverview Exports job type enum.
 */
enum JobTypeEnum {
  JOB_PER_TEMPLATE = 'job_per_template',
  JOB_PER_LINK = 'job_per_link',
  JOB_PER_FILE = 'job_per_file',
  JOB_PER_BACKFILL = 'job_per_backfill',
}

export default JobTypeEnum;
